import HealthInfoQuestion from 'components/Dashboard/components/SurveyPage/components/V2/HealthInfoQuestion/HealthInfoQuestion';
import { QuestionPageProps } from 'components/Dashboard/components/SurveyPage/types';

import React from 'react';

const DISEASES = [
  'Depression',
  'Obsessive compulsive disorder',
  'Bipolar disorder',
  'Schizophrenia',
  'Attention-deficit/hyperactivity',
  'Other',
];

const MentalIllnessQuestion: React.FC<QuestionPageProps> = ({ onNext, onPrev, onSubmit }) => {
  return <HealthInfoQuestion onPrev={onPrev} onNext={onNext} onSubmit={onSubmit} field="mentalIllness" diseases={DISEASES} />;
};

export default MentalIllnessQuestion;
